/**
 * Per-user display preferences, stored locally in the browser: default
 * currency, price unit and chart range. These only affect what this browser
 * draws, so there is nothing for the server to know. Pages read them once on
 * mount for their initial state, so a change applies the next time the page
 * is opened.
 *
 * The alert email opt-in deliberately does NOT live here: the server has to
 * read it to honour it. See /api/account/settings.
 */

const KEY = (email) => `farmgate-prefs-${email || 'anon'}`;

export const PREF_DEFAULTS = {
  currency: 'USD',    // Commodities page currency
  priceUnit: 'bag',   // Markets price-records unit
  chartRange: '3M',   // Dashboard / Currency default chart window
};

export function getPrefs(email) {
  try {
    return { ...PREF_DEFAULTS, ...JSON.parse(localStorage.getItem(KEY(email)) || '{}') };
  } catch {
    return { ...PREF_DEFAULTS };
  }
}

export function setPref(email, key, value) {
  const next = { ...getPrefs(email), [key]: value };
  try { localStorage.setItem(KEY(email), JSON.stringify(next)); } catch {}
  return next;
}
